import { Form as FormikForm, useFormikContext } from 'formik';
import { useNavigate } from 'react-router-dom';

import { Button } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import Navigation from 'hb-react/shared/apps/Events/pages/Booking/components/Navigation';
import { ReCaptcha } from 'hb-react/shared/apps/Events/pages/Booking/components/ReCaptcha';
import { Section } from 'hb-react/shared/apps/Events/pages/Booking/components/Section';
import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import { ButtonNext } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/components/ButtonNext';
import { Form } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/components/Form/form.component';
import { StandaloneAddons } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/components/Form/StandaloneAddons';
import { type FormValues } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/types';
import { requiresBillingPage } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/utils';
import ErrorFocus from 'hb-react/shared/components/formik/components/ErrorFocus';

const ArrowLeftIcon = () => (
  <FontAwesomeIcon
    iconName="chevron-left"
    height="16px"
    iconType={CATEGORIES.SOLID}
  />
);

export const FormFields = () => {
  const { addons, cart, isLoading, isMutating } = useBooking();

  const { values } = useFormikContext<FormValues>();

  const navigate = useNavigate();
  const withBillingStepWorkflow = requiresBillingPage(cart, values);

  const isShippable = cart?.cart_items?.find(
    ({ quantity, is_shippable: isShippable }) => quantity > 0 && isShippable,
  );

  return (
    <FormikForm>
      <Section>
        <Form />
        <StandaloneAddons addons={addons} />
        {!withBillingStepWorkflow && <ReCaptcha />}
      </Section>
      <Navigation>
        {({ isFixed }) => (
          <>
            <Button
              variant="secondary"
              mr={4}
              // @ts-expect-error: fix types
              icon={!isFixed && ArrowLeftIcon}
              onClick={() => navigate('../ticket-selection')}
            >
              {isFixed
                ? s__('NetworkEvents|Back')
                : s__('NetworkEvents|Go back to Ticket Selection')}
            </Button>
            <ButtonNext
              isFixed={isFixed}
              isLoading={isLoading || isMutating}
              isShippable={isShippable}
              withBillingStepWorkflow={withBillingStepWorkflow}
            />
          </>
        )}
      </Navigation>
      <ErrorFocus />
    </FormikForm>
  );
};
